import { render, staticRenderFns } from "./EmployeeTestiomoni.vue?vue&type=template&id=d4973fa2&"
import script from "./EmployeeTestiomoni.vue?vue&type=script&lang=js&"
export * from "./EmployeeTestiomoni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports